import { Link } from 'react-router-dom';

export default function MenuWidget({ data }) {
  return (
    <ul className="cs_menu_widget cs_mp0">
      {data?.map((item, index) => (
        <li key={index} style={{ paddingTop: '24px' }}>
          {/* <Link to={item.href} style={{ "fontSize": "16px", "lineHeight": "1.5", "fontWeight": "600", "color": "#fff" }}>{item.title}</Link> */}
          {item.href.startsWith("http") ? (
            <a
              href={item.href}
              style={{
                fontSize: "16px",
                lineHeight: "1.5",
                fontWeight: "600",
                color: "#fff",
              }}
            >
              {item.title}
            </a>
          ) : (
            <Link
              to={item.href}
              style={{
                fontSize: "16px",
                lineHeight: "1.5",
                fontWeight: "600",
                color: "#fff",
              }}
            >
              {item.title}
            </Link>
          )}
        </li>
      ))}
    </ul>
  );
}
